'use strict';

module.exports = '2.28.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 324
// module chunks = 142807904292071